import React, { ReactNode } from 'react';
import './modal.css'
import colors from '../../../utils/colors';
import { cancel } from './assets';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  title: string
  className?: string
  hasClose?: boolean
}

const Modal: React.FC<ModalProps> = ({ isOpen, hasClose = true, onClose, children, title, className= 'w-[40%] min-w-[500px] max-w-[600px] p-[50px]' }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="modal-overlay" onClick={onClose}></div>
      <div className={`modal-container ${className} bg-white rounded-md shadow-lg z-50`}>
        <div className='flex justify-between items-center'>
            <div style={{color: colors.dark, fontSize: '18px'}}>{title}</div>
            {hasClose && <img src = {cancel} alt = '' onClick={onClose} className='h-[20px] cursor-pointer'/>}
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;
